export const POSTING_PERMISSION_HELP_IMAGE =
  "https://user-cdn.hackclub-assets.com/019fb8f0-b563-7018-b7c3-a6ecbc662935/sl7px4k.png";

export const POSTING_PERMISSION_ERROR =
  "bChannel isn’t allowed to post in this channel. Open the channel settings, choose Posting permissions, add bChannel under “Admins, plus specific people,” then save. Your draft is safe.";

export const BOT_NOT_IN_CHANNEL_ERROR =
  "bChannel isn’t in this private channel. Add bChannel to the channel, then try again. Your draft is safe.";
